(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
function logout() {
  FB.logout()
}

function connect() {
  var b = $(this);
  if (b.closest("form").length) {
    b.closest("form").showLoading()
  }
  FB.login(function(c) {
    if (c.authResponse) {
      location.href = b.attr("data-href")
    } else {
      b.closest("form").hideLoading()
    }
  }, {
    scope: "public_profile,email,user_birthday,user_likes,publish_actions"
  })
}

function friendRequest() {
  FB.ui({
    method: "apprequests",
    message: "I'm using JustPark to save money on parking by renting driveways and private car parking spots directly from home and business owners. Also worth a look if you have a spare parking spot that could be rented out.",
    data: window.location.href,
    title: "Share JustPark with your friends",
    filters: ["app_non_users"]
  }, function() {})
}

function publish() {
  $this = $(this);
  var b = {
    method: "feed",
    link: $this.attr("data-url"),
    picture: $this.attr("data-photo-url") ? $this.attr("data-photo-url") : "",
    name: "JustPark.com",
    caption: $this.attr("data-caption") ? $this.attr("data-caption") : "",
    description: $this.attr("data-description") ? $this.attr("data-description") : ""
  };
  FB.ui(b, function() {
    analytics.track('publish-feed', {
        'category' : 'social',
        'label' : 'Facebook',
        'value' : $this.attr("data-url")
      });
  })
}


$(function() {
  $("body").on("click.logout", ".fb-enabled .fb-logout", function(a) {
    a.preventDefault();
    logout();
  });
  $("body").on("click.connect", ".fb-enabled .fb-connect", function(a) {
    a.preventDefault();
    connect.apply(this);
  });
  $("body").on("click.friend", ".fb-enabled .fb-friend-request", function(a) {
    a.preventDefault();
    friendRequest();
  });
  $("body").on("click.publish", ".fb-enabled .fb-publish-feed", function(a) {
    a.preventDefault();
    publish.apply(this);
  });
});

},{}]},{},[1]);
